import React, { useState } from 'react'
import { usePageTracking } from '@/utils/hooks/use-page-tracking'
import { Routes, Route } from 'react-router-dom'
import Layout from '@/components/layout'
import Homepage from '@/pages/homepage'
import News from '@/pages/news'
import NewsDetail from '@/pages/news/detail'
import Contact from '@/pages/contact'
import Solution from '@/pages/solutions/index'
import SolutionDetail from '@/pages/solutions/[type]'
import Carbon from '@/pages/carbon'
import AI from '@/pages/ai'
import AboutUs from '@/pages/about-us'
import VisitCharts from '@/pages/visit-charts'
import 'bootstrap/dist/css/bootstrap.min.css'
import { ThemeProvider } from 'react-bootstrap'
import { px2remTransformer, StyleProvider } from '@ant-design/cssinjs'
import { ConfigProvider } from 'antd'
import ProductTemplate from './pages/product-template/[name]'
import SchoolBus from '@/pages/solutions/school-bus'
import DisasterRelief from '@/pages/solutions/disaster-relief'
import ServiceSupport from '@/pages/service-support'

const theme = {
  token: {
    // Seed Token，影响范围大
    colorPrimary: '#00BDE1',
    // borderRadius: 2,
    // 派生变量，影响范围小
    // colorBgContainer: '#f6ffed',
  },
}

const LayoutComponents = props => <Layout {...props}></Layout>

export const GlobalContext = React.createContext(null)

const px2rem = px2remTransformer({
  rootValue: 16, // 16px = 1rem
})

function App() {
  const [globalProps, setGlobalProps] = useState({
    lang: localStorage.lang || 'en',
  })

  usePageTracking()

  return (
    <GlobalContext.Provider value={{ globalProps, setGlobalProps }}>
      <ConfigProvider theme={theme}>
        <StyleProvider transformers={[px2rem]}>
          <ThemeProvider>
            {/* <ThemeProvider breakpoints={['xxxl', 'xxl', 'xl', 'lg', 'md', 'sm']} minBreakpoint='sm'> */}
            <Routes>
              <Route path='/' element={<LayoutComponents />}>
                {/* 首页 */}
                <Route index element={<Homepage />} />

                {/* 解决方案动态路由 */}
                <Route path='/solution'>
                  <Route index element={<Solution />} />
                  <Route path=':type' element={<SolutionDetail />} />
                </Route>

                {/* 学校巴士 */}
                <Route path='/solution/school-bus' element={<SchoolBus />} />

                {/* 灾难救助 */}
                <Route path='/solution/disaster-relief' element={<DisasterRelief />} />

                {/* 产品详情模板 */}
                <Route path='/product-template'>
                  <Route index element={<ProductTemplate />} />
                  <Route path=':name' element={<ProductTemplate />} />
                </Route>

                {/* 服务 */}
                <Route path='/carbon' element={<Carbon />} />
                <Route path='/ai' element={<AI />} />

                {/* 访问统计 */}
                <Route path='/visit-charts' element={<VisitCharts />} />

                {/* 新闻 */}
                <Route path='/news' element={<News />} />
                <Route path='/news-detail' element={<NewsDetail />} />

                {/* 服务支持 */}
                <Route path='/service-support' element={<ServiceSupport />} />

                {/* 关于我们 */}
                <Route path='/about-us' element={<AboutUs />} />
                <Route path='/contact' element={<Contact />} />

                {/* 404 */}
                <Route path='*' element={<div>404</div>} />
              </Route>
            </Routes>
          </ThemeProvider>
        </StyleProvider>
      </ConfigProvider>
    </GlobalContext.Provider>
  )
}

export default App
